import * as React from 'react';
import '../../scss/globals.scss';

const AppWrapper: React.FC = ({children}) => {
  return <>{children}</>
};

export default AppWrapper;
